import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import {
  FaLaptopCode,
  FaChartBar, 
  FaRoad
} from 'react-icons/fa';
import { GrVirtualMachine } from "react-icons/gr";
import { MdOutlineDesignServices } from "react-icons/md";
import { MdInsights } from "react-icons/md";
import { VscGraphLine } from "react-icons/vsc";
export default function CreativeTeam() {
const services = [
  {
    icon: <FaRoad size={40} color="#E91E63" />,
    title: "AI Strategy & Roadmap",
    subtitle: "Plan. Prioritize. Scale."
  },
  {
    icon: <FaLaptopCode size={40} color="#E91E63" />,
    title: "AI Development & Engineering",
    subtitle: "Build. Automate. Innovate."
  },
  {
    icon: <GrVirtualMachine size={40} color="#E91E63" />,
    title: "Data Intelligence & Machine Learning",
    subtitle: "Analyze. Predict. Optimize."
  },
  {
    icon: <MdOutlineDesignServices size={40} color="#E91E63" />,
    title: "AI UX & Human-Centered Design",
    subtitle: "Simplify. Engage. Delight."
  },
  {
    icon: <MdInsights size={40} color="#E91E63" />,
    title: "AI-Driven Growth & Insights",
    subtitle: "Strategize. Amplify. Convert."
  },
  {
    icon: <VscGraphLine size={40} color="#E91E63" />,
    title: "AI Operations & Continuous Improvement",
    subtitle: "Monitor. Enhance. Evolve."
  }
];


  return (
    <div style={styles.wrapper}>
      <Container fluid className='mt-4'>
        <Row className="align-items-center">
          <Col lg={4} className="p-5">
            <div style={styles.leftSection}>
              <p style={styles.tagline}>THE FOXTROIT TEAM</p>
              <h2 style={styles.mainHeading}>
                Empowering Businesses <br /> Through Intelligent AI
              </h2>
              <p style={styles.description}>
               At Foxtroit, we craft AI solutions that redefine business intelligence.From ideation to deployment, we merge cutting-edge algorithms, automation, and data-driven insights to create systems that learn, adapt, and deliver measurable impact.
              </p>
          
              <Link to="/contact" style={{ textDecoration: "none", color: "inherit" }}>
    <Button style={styles.ctaButton}>
                Connect With Us →
              </Button>
  </Link>
            </div>
          </Col>
          
          <Col lg={8} className="p-0">
            <Row className="g-0">
              {services.map((service, index) => (
                <Col md={6} key={index} style={styles.serviceCol}>
                  <div style={styles.serviceCard}>
                    <div style={styles.iconWrapper}>
                      <span style={styles.icon}>{service.icon}</span>
                    </div>
                    <div style={styles.serviceContent}>
                      <h3 style={styles.serviceTitle}>{service.title}</h3>
                      <p style={styles.serviceSubtitle}>{service.subtitle}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const styles = {
  wrapper: {
    backgroundColor: '#ffffff',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center'
  },
  leftSection: {
    padding: '20px'
  },
  tagline: {
    color: '#E91E63',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '1px',
    marginBottom: '20px'
  },
  mainHeading: {
    fontSize: '3.5rem',
    fontWeight: '500',
    lineHeight: '1.2',
    marginBottom: '30px',
    color: '#1a1a1a'
  },
  description: {
    fontSize: '16px',
    color: '#999999',
    lineHeight: '1.8',
    marginBottom: '40px'
  },
  ctaButton: {
    backgroundColor: '#2d2d2d',
    border: 'none',
    padding: '15px 35px',
    fontSize: '16px',
    borderRadius: '4px',
    fontWeight: '500',
    transition: 'all 0.3s ease'
  },
  serviceCol: {
    borderRight: '1px solid #e0e0e0',
    borderBottom: '1px solid #e0e0e0'
  },
  serviceCard: {
    padding: '40px 35px',
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    backgroundColor: '#ffffff',
    transition: 'all 0.3s ease'
  },
  iconWrapper: {
    fontSize: '2.5rem'
  },
  icon: {
    display: 'inline-block'
  },
  serviceContent: {
    flex: 1
  },
  serviceTitle: {
    fontSize: '1.25rem',
    fontWeight: '500',
    marginBottom: '10px',
    color: '#1a1a1a'
  },
  serviceSubtitle: {
    fontSize: '15px',
    color: '#999999',
    margin: 0,
    lineHeight: '1.6'
  }
};